module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Sam_Picking_his_vitamins-Web-640.bb5525e3.jpg";